import { i18n } from '@fs/zion-locale'
import personIcon from '../assets/icons/personGroup.svg'

const isOrdinanceSharingOnly = (types) => {
  return types?.length === 1 && types?.[0] === 'ORDINANCE_SHARING'
}

const getFamilyGroupsAndIndividuals = ({ familyGroups }) => {
  const allPersonsInAllGroups = familyGroups?.reduce((allPersonsAccumulator, famGroup) => {
    if (famGroup?.persons) {
      const group = { groupId: famGroup?.group?.id, treeId: famGroup?.group?.treeId }
      famGroup?.persons.forEach((person) => {
        if (person?.status === 'PENDING') return
        const match = allPersonsAccumulator.find((accPerson) => accPerson?.memberCisId === person?.memberCisId)
        if (match && match?.groups) match.groups.push(group)
        else {
          delete person?.groupId
          allPersonsAccumulator.push({ ...person, groups: [group] })
        }
      })
    }
    return allPersonsAccumulator
  }, [])

  const expandedFamilyGroups =
    familyGroups?.map((item) => {
      return {
        familyGroupId: item?.group?.id,
        treeId: item?.group?.treeId,
        name: item?.group?.name,
        imageUrl: item?.group?.imageUrl,
        isGroup: true,
        persons: item?.persons ?? [],
      }
    }) ?? []

  const allGroup = {
    familyGroupId: 'ALL',
    name: i18n.t('familygroups.all-family-groups'),
    imageUrl: personIcon,
    persons: allPersonsInAllGroups ?? [],
  }

  return [allGroup, ...expandedFamilyGroups]
}

const addImageLookupUrlsToInvitations = ({ invitations, familyGroups }) => {
  const allFamilyGroup = familyGroups?.find((individualFamilyGroup) => individualFamilyGroup.familyGroupId === 'ALL')
  const invitationsToUse = invitations
    ?.map((invitation) => {
      const individual = allFamilyGroup?.persons.find((person) => person.memberCisId === invitation.cisUserId)
      return { ...invitation, person: individual }
    })
    // Remove invitations that don't have a person object.  This could occur if the user was removed from a group after invitations were sent to the user.
    .filter((item) => item?.person)
    .sort((a, b) => new Date(b.invitationDate) - new Date(a.invitationDate)) // order them by invitationDate descending (so most recent is first)
  return invitationsToUse
}

const buildInvitationMap = (invitations) => {
  if (!invitations?.length) return new Map()
  return invitations.reduce((map, invitation) => {
    const key = invitation.activityGroupId
    if (!key) return map
    const list = map.get(key)
    if (list) list.push(invitation)
    else map.set(key, [invitation])
    return map
  }, new Map())
}

const getInvitedActivityGroups = ({ categories, invitations }) => {
  if (!categories?.length || !invitations?.length) return []
  const invitationMap = buildInvitationMap(invitations)
  const invitedActivityGroups = []

  categories.forEach((category) => {
    category?.activityGroups?.forEach((activityGroup) => {
      const groupInvitations = invitationMap.get(activityGroup.activityGroupId)
      if (groupInvitations?.length) {
        invitedActivityGroups.push({
          ...activityGroup,
          invitations: groupInvitations,
        })
      }
    })
  })

  return invitedActivityGroups
}

const getIsChild = (birthDate) => {
  const birthDateObj = new Date(birthDate)
  const diff_ms = Date.now() - birthDateObj.getTime()
  const age_dt = new Date(diff_ms)
  const age = Math.abs(age_dt.getUTCFullYear() - 1970)
  return age < 18
}

export {
  isOrdinanceSharingOnly,
  getFamilyGroupsAndIndividuals,
  addImageLookupUrlsToInvitations,
  getInvitedActivityGroups,
  getIsChild,
}
